import Glide from "@glidejs/glide";

const eventCardSliderHandler = () => {
	const eventSliders = document.querySelectorAll(".what-on-tiles__glide");

	eventSliders.forEach((slider, i) => {
		const autoplay = slider.dataset.autoplay;
		// Check if the slider has already been initialized
		if (!slider.hasAttribute("data-initialized")) {
			new Glide(slider, {
				type: "carousel",
				startAt: 0,
				perView: 1,
				autoplay: Number(autoplay),
				gap: 10,
			}).mount();
			// Mark the slider as initialized
			slider.setAttribute("data-initialized", "true");
		}
	});
};

if (document.readyState !== "loading") {
	eventCardSliderHandler();
} else {
	document.addEventListener("DOMContentLoaded", eventCardSliderHandler);
}
